import { render, staticRenderFns } from "./businessDetails.vue?vue&type=template&id=3d789b6a&"
import script from "./businessDetails.vue?vue&type=script&lang=ts&"
export * from "./businessDetails.vue?vue&type=script&lang=ts&"
import style0 from "./businessDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports